export const opcionesMenu = [
  {
    namePath: "/",
    texto: "Inicio",
  },
  {
    namePath: "/agenda",
    texto: "Agenda",
  },
  {
    namePath: "/acercade",
    texto: "Acerca de nosotros",
  },
  {
    namePath: "/contacto",
    texto: "Contacto",
  },
];
